import api from './client';
import logger from '../utils/logger';

export interface LoginData {
  username: string;  // 实际应该是email
  password: string;
}

export interface RegisterData {
  username?: string;  // 用户名改为可选
  email: string;
  password: string;
  pin: string;
  referral_code?: string;  // 推荐码（可选）
}

export interface User {
  id: number;
  username: string;
  email: string;
  full_name?: string;
  membership_level: string;
  quota_remaining: number;
  total_quota_used: number;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
}

export const authAPI = {
  // 登录 - 通过后端API调用（统一API调用路径）
  login: async (data: LoginData): Promise<AuthResponse> => {
    // 从username字段提取email（前端可能传入email到username字段）
    const email = data.username.includes('@') ? data.username : data.username;
    
    logger.log('🔐 通过后端API登录', { email });
    
    const response = await api.post('/api/auth/login', {
      username: email,  // 后端期望username字段，但实际会按email处理
      password: data.password,
    });
    
    // 后端返回格式：{ access_token: string, token_type: string }
    return response.data;
  },

  // 注册
  register: async (data: RegisterData): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/register', data);
    return response.data;
  },

  // 获取当前用户信息
  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  // 更新用户信息
  updateProfile: async (data: Partial<User>): Promise<User> => {
    const response = await api.put('/api/auth/me', data);
    return response.data;
  },

  // 忘记密码 - 验证PIN码并重置密码
  forgotPassword: async (email: string, pin: string, newPassword: string): Promise<void> => {
    const response = await api.post('/api/auth/forgot-password', {
      email,
      pin,
      new_password: newPassword,
    });
    return response.data;
  },
};
